import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LoaderCircle } from "lucide-react";

const HOTEL_ROLES = ["otel_owner", "otel_manager", "otel_reception", "otel_accounting"];

// Thin redirector — sends otel_* users to the existing admin page scoped to
// their hotel_id. Used for /h/calendar → /admin/hotels/{id}/calendar and
// /h/yield → /admin/hotels/{id}/yield. The admin endpoints accept otel_*
// roles via the `get_admin_or_hotel_owner` dep.
export default function HotelCalendarRedirect() {
    const { user, loading } = useAuth() || {};
    const navigate = useNavigate();
    const loc = useLocation();
    // Map /h/<target> → /admin/hotels/<id>/<target>
    const target = loc.pathname.endsWith("/yield") ? "yield" : "calendar";

    useEffect(() => {
        if (loading) return;
        if (!user) return navigate("/h/login");
        if (HOTEL_ROLES.includes(user.role) && user.hotel_id) {
            navigate(`/admin/hotels/${user.hotel_id}/${target}`, { replace: true });
        } else if (["admin", "super_admin"].includes(user.role)) {
            navigate("/admin/hotels");
        } else {
            navigate("/admin");
        }
    }, [user, loading, navigate, target]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
            <LoaderCircle className="h-8 w-8 text-emerald-500 animate-spin" />
        </div>
    );
}
